/**
 * @module support/pdl
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */

// tslint:disable

import { Injectable } from '@angular/core';
import { NgRadio } from '../components/ng-radio.component';
import { PdlService } from './pdl.service';

@Injectable()
export class InjectablePDLService {
  private isPdlDataAvailable: boolean;
  public eventBus: NgRadio;
  constructor(public pdlService: PdlService) {
    this.eventBus = this.pdlService.getEventBus();
  }

  public trackData(pageIdentifier: string, ctaId: string, data: Object): void {
    if (pageIdentifier && ctaId && data) {
      this.eventBus.cast('pdl: track-data-event', {
        pageIdentifier: pageIdentifier,
        ctaId: ctaId,
        data: data,
      });
    }
  }

  public setDataTrackConfig(data: Object): void {
    if (data) {
      this.eventBus.cast('pdl: config-data-track-event', data);
    }
  }

  public setCustomHandlers(data: Object): void {
    if (data) {
      this.eventBus.cast('pdl: config-handlers-event', data);
    }
  }

  public setEventCaptureConfig(data: Object, global: boolean = false): void {
    if (data) {
      // this.eventBus.cast('pdl: config-event-capture-event', data,);
      this.pdlService.setPDLData(data, global);
    }
  }

  public triggerEvent(componentId: string, ctaId: string): void {
    this.pdlService.triggerCustomEvent(componentId, ctaId);
  }

  public disable(): void {
    this.eventBus.cast('pdl: disable-tracking-event');
  }
}
